/**
 * @file WmsWarehousesPage.tsx
 * @description Справочник складов (phase13.0): создание, правка, склад по
 * умолчанию, деактивация. Общий стиль — phase19.23, A6; phase19.31 зона
 * «Склад» — переведён целиком на Commora.
 *
 * Заголовок «Склады» в верхней панели, главное действие одно — «+ Склад»
 * (раньше в коде было три одинаковые кнопки «Новый склад» в разных ветках).
 * На телефоне и планшете — в общей нижней полосе. Форма создания и правки
 * открывается над списком; пока она открыта, кнопки «+ Склад» нет.
 *
 * phase19.14 (W8): вид склада и флаг «Доступен для продажи». Снятие флага у
 * склада с активными резервами сервер отклоняет 409
 * `warehouse_has_active_reservations` — текст показываем как есть.
 *
 * Данные и операции — в `useWarehousesPage`, список — в `WarehousesList`.
 */

import { Plus } from "lucide-react";

import { Button } from "../../../components/ui/button";
import { CabinetPageHeader } from "../../../components/ui/CabinetPageHeader";
import { WarehouseDraftForm } from "../../../components/wms/WarehouseDraftForm";
import { WmsConfirmDialog } from "../../../components/wms/WmsConfirmDialog";
import { WarehousesList } from "../../../components/wms/WarehousesList";
import { useWarehousesPage } from "../../../components/wms/useWarehousesPage";

export function WmsWarehousesPage() {
  const page = useWarehousesPage();
  const formOpen = page.creating || !!page.editingId;

  return (
    <div className="flex flex-col gap-4">
      <CabinetPageHeader
        title="Склады"
        subtitle="Места хранения товара: адрес, тип и участие в продаже"
        action={
          formOpen ? undefined : (
            <Button variant="brand" onClick={page.startCreate}>
              <Plus className="size-4" />
              Склад
            </Button>
          )
        }
      />

      {formOpen ? (
        <WarehouseDraftForm
          value={page.draft}
          onChange={page.setDraft}
          editing={!!page.editingId}
          saving={page.saving}
          onSave={() => void page.save()}
          onCancel={page.cancel}
        />
      ) : null}

      <WarehousesList
        items={page.items}
        loading={page.loading}
        error={page.error}
        onRetry={() => void page.refresh()}
        onEdit={page.startEdit}
        onSetDefault={(w) => void page.setDefault(w)}
        onDeactivate={(w) => void page.deactivate(w)}
      />
      <WmsConfirmDialog request={page.confirmRequest} onSettle={page.settleConfirm} />
    </div>
  );
}
